import { CoreMenu } from 'src/@core/types';

export const qaMenu: CoreMenu[] = [
  {
    id: 'QA',
    title: 'Quality Assurance',
    type: 'collapsible',
    icon: 'qa.svg',
    role: {
      roles: ['employee'],
      right: ['H1038', 'H1043', 'H1032'],
    },
    children: [
      {
        id: 'Test-Scenario',
        title: 'Test Scenario',
        type: 'item',
        icon: 'test-scenario.svg',
        url: '/i-team/qa/test-scenarios',
        role: {
          roles: ['employee'],
          right: 'H1043',
        },
      },
      {
        id: 'Test-Activity',
        title: 'Test Activity',
        type: 'item',
        icon: 'test-activity.svg',
        url: '/i-team/qa/test-activity',
        role: {
          roles: ['employee'],
          right: 'H1032',
        },
      },
      {
        id: 'Test Result',
        title: 'Test Result',
        type: 'item',
        icon: 'test-result.svg',
        url: '/i-team/qa/testing-scenarios',
        role: {
          roles: ['employee'],
          right: 'H1038',
        },
      },
    ],
  },
];
